export default __webpack_public_path__ + "static/media/july2023-5.428b9df9.jpg";